import Immutable from 'seamless-immutable';
import { handleActions } from 'redux-actions';
import { sectors as actionTypes } from '$constants/action-types';

const defaultState = Immutable({
  items: []
});

const reducer = {
  [actionTypes.FETCH_ALL_SUCCESS](state, action) {
    return state.setIn(['items'], action.result);
  }
}

export default handleActions(reducer, defaultState);



// WEBPACK FOOTER //
// ./src/reducers/sectors.js